let postProcessingFn = (data) => data;
let stringify = false;

function configure(config) {
    postProcessingFn = config.postProcessingFn ?? postProcessingFn;
    stringify = config.stringify ?? stringify;
}

function debug(context, ...args) {
    _addEvent('debug', context, args);
}

function log(context, ...args) {
    _addEvent('log', context, args);
}

function info(context, ...args) {
    _addEvent('info', context, args);
}

function warn(context, ...args) {
    _addEvent('warn', context, args);
}

function error(context, ...args) {
    _addEvent('error', context, args);
}

// eslint-disable-next-line default-param-last
function _tempLogFormatEval(level, component, label, message, context = {}, extraContext = [], metadata) {
    const missingComponent = !component;
    const componentInvalidType = typeof component !== 'string';
    const missingLabel = !label;
    const labelInvalidType = typeof label !== 'string';
    const missingMessage = !message;
    const messageInvalidType = !(context instanceof Error) && !['string', 'number', 'boolean', 'object'].includes(typeof message);
    const contextInvalidType = context instanceof Error || !['string', 'object', 'boolean'].includes(typeof context);
    const missingMetadata = !metadata;
    const metadataInvalidType = typeof metadata !== 'object';
    const hasExtraContext = extraContext.length > 0;
    const malformedLog = missingComponent || componentInvalidType || missingLabel
        || labelInvalidType || missingMessage || messageInvalidType || contextInvalidType
        || missingMetadata || metadataInvalidType || hasExtraContext;

    if (malformedLog) {
        _addEvent('warn', 'ConsoleLogger', ['logFormatEval', 'invalid log format', {
            rules: {
                missingComponent,
                componentInvalidType,
                missingLabel,
                labelInvalidType,
                missingMessage,
                messageInvalidType,
                contextInvalidType,
                missingMetadata,
                metadataInvalidType,
                hasExtraContext,
            },
            arguments: {
                level,
                component,
                label,
                message,
                context,
                metadata,
                extraContext,
            },
        }, {}]);
    }
}

function formatError(err) {
    // XX: JSON.stringify doesn't handle errors well. We need to manually map
    //    (not spread) the error properties into JSON  or they will get dropped
    return {
        message: err.message,
        stack: err.stack,
        name: err.name,
    };
}

function _addEvent(level, component, args) {
    const metadata = args.pop();
    const [label, message = undefined, context, extraContext] = args;
    _tempLogFormatEval(level, component, label, message, context, extraContext, metadata);

    let data = {
        level,
        component,
        label,
        timestamp: new Date().toISOString(),
        metadata,
        context,
        extraContext,
    };

    if (message instanceof Error) {
        data = {
            ...data,
            error: formatError(message),
        };
    } else {
        data.message = message;
    }

    const processedData = postProcessingFn(data);
    console[level](stringify
        ? JSON.stringify(processedData)
        : processedData);
}

export default {
    debug,
    log,
    info,
    warn,
    error,
};

export { configure };
